import { ControlledDto } from 'src/Libs/flow/installation/api'
import { parseEebusChargingStation } from './eebus'
import { getIsEvseExpandedFromCache } from './evse-is-expanded-cache'
import { parseModbusTcpChargingStation } from './modbus-tcp'
import { InstallationFormModel } from 'src/Libs/flow/installation/forms'

const groupChargingStationsByMedia = (
  evses: Nullable<ControlledDto>[]
): {
  modbusTcp: Nullable<ControlledDto>[]
  eebus: Nullable<ControlledDto>[]
} => {
  const modbusTcp: Nullable<ControlledDto>[] = evses.filter(({ media }) => media === 'ModbusTCP')
  const eebus: Nullable<ControlledDto>[] = evses.filter(({ media }) => media === 'EEBus')

  return {
    modbusTcp,
    eebus,
  }
}

/** DTO to form charging stations */
export const parseChargingStations = (evse: Nullable<ControlledDto>[]): InstallationFormModel['chargingStations'] => {
  const { modbusTcp, eebus } = groupChargingStationsByMedia(evse)
  return {
    modbusTcp: modbusTcp.map(parseModbusTcpChargingStation),
    eebus: eebus.map(parseEebusChargingStation),
  }
}

export const getCharginStationExpandedState = (
  chargingStations: InstallationFormModel['chargingStations']
): InstallationFormModel['chargingStationsExpandedState'] => {
  const { modbusTcp, eebus } = chargingStations

  return {
    modbusTcp: Object.fromEntries(modbusTcp.map(({ id, deviceId }) => [id, getIsEvseExpandedFromCache(deviceId)])),
    eebus: Object.fromEntries(eebus.map(({ id, deviceId }) => [id, getIsEvseExpandedFromCache(deviceId)])),
  }
}
